import React from 'react';
const Home = () => {
  return (
    <main>
      <h2>Home</h2>
    </main>
  );
};
export default Home;
